<ng-container *ngIf="!(datosRecibidos1); else datosCargados">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-template #datosCargados>
    <div *ngIf="hayAlarmasActivadas" class="alarmasContainer">
        <mat-expansion-panel #panel class="expansionPanel" hideToggle>
            <mat-expansion-panel-header class="headerAlarmasContainer">
                <mat-panel-title class="panelTitle">
                    <div class="alarmasActivasContainer">
                        <mat-icon class="warningIcon material-symbols-outlined">warning</mat-icon>
                        <span class="alarmasActivasTitulo">
                            <span class="alarmasActivasN">{{numeroAlarmasActivadas}}</span> 
                            <span>ALARMAS ACTIVAS !</span>
                        </span>
                        <!--ICONO PERSONALIZADO DE ABIERTO Y CERRADO-->
                        <mat-icon *ngIf="panel.disabled !== true" 
                        [ngClass]="{'customExpansionPanelIconOpen': panel.expanded, 'customExpansionPanelIconClosed': !panel.expanded}">
                            arrow_downward
                        </mat-icon>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="tableContainer">
                <table mat-table [dataSource]="dataSourceAlarmsActivas" matSort #sort2="matSort" class="alarmasTable">
        
                    <ng-container matColumnDef="deviceLabel">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispositivo </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{ element.deviceLabel }} ({{ element.deviceRef }}) </td>
                    </ng-container>

                    <ng-container matColumnDef="f_inicio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Inicio </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.type}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valorAlarma">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor Alarma </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.valorAlarma}} </td>
                    </ng-container>
        
                    <ng-container matColumnDef="rango">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                        <td mat-cell *matCellDef="let element" class="cell"> {{element.rango}} </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsActivas"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsActivas;"></tr>
                </table>
            </div>
        </mat-expansion-panel>
    </div>

    <div class="table" class="mat-elevation-z8">
        <!-- <div class="table-header">
            <div class="header-content">
                <span class="header-grande">{{establecimientoActual.est_name}}&nbsp;</span> -->
                <!-- <span class="tiempoReal">TIEMPO REAL&nbsp;</span> -->
                <!-- <img *ngIf="establecimientoActual?.status === 1 && (establecimientoActual?.devices.length != alarmasDesconexion.length)" src="assets/images/wifi-on.png" alt="Icon" class="tiempoRealImagen"/>
                <img *ngIf="establecimientoActual?.status === 0 || (establecimientoActual?.devices.length === alarmasDesconexion.length)" src="assets/images/wifi-off.png" alt="Icon" class="tiempoRealImagen"/>
                <div *ngIf="alarmasConOO.length > 0 && (establecimientoActual?.devices.length != alarmasDesconexion.length) && establecimientoActual?.status === 1" class="desconexion-info">
                    <span class="desconexion-alerta">
                        Sin lecturas en:
                    </span>
                    <div class="desconexion-detalle">
                        <div *ngFor="let item of alarmasDesconexion">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div class="sol-icons-container">
                    <div class="sol-icon">
                        <mat-icon>wb_sunny</mat-icon>&nbsp;&nbsp;{{soloDosDecimalesConString(temperaturaAmbienteActual)}}&nbsp;ºC
                    </div>
                    <div class="sol-icon1">
                        <mat-icon class="storeIcon">store</mat-icon> &nbsp;&nbsp;{{temperaturaAmbiente}}&nbsp;ºC -->
                    <!-- </div>
                </div>
            </div>
            <div class="ultimo-historico">
                <span>Última lectura: {{devolverUltimaLecturaFormateada(fechaUltimoHistorico)}}</span>
            </div>
        </div> -->
        <div class="table-header">
            <div class="header-content">
                <div class="info-establecimiento">
                    <div class="contenedor-nombre-wifi">
                        <span class="header-grande">{{ establecimientoActual.est_name }}</span>
                        <img
                            *ngIf="establecimientoActual?.status === 1 && (establecimientoActual?.devices.length != alarmasDesconexion.length)"
                            src="assets/images/wifi-on.png"
                            alt="WiFi On"
                            class="tiempoRealImagen" />

                        <img
                            *ngIf="establecimientoActual?.status === 0 || (establecimientoActual?.devices.length === alarmasDesconexion.length)"
                            src="assets/images/wifi-off.png"
                            alt="WiFi Off"
                            class="tiempoRealImagen" />
                        </div>
                    <div class="ultimo-historico">
                        Última lectura: {{ devolverUltimaLecturaFormateada(fechaUltimoHistorico) }}
                    </div>
                </div>

                <div class="info-alarmas" *ngIf="alarmasConOO.length > 0 && (establecimientoActual?.devices.length != alarmasDesconexion.length) && establecimientoActual?.status === 1">
                    <span class="texto-alarmas">Sin lecturas en:</span>
                    <div class="lista-alarmas">
                        <div *ngFor="let item of alarmasDesconexion">{{ item }}</div>
                    </div>
                </div>

                <div class="sol-icons-container">
                    <div class="sol-icon1">
                        <mat-icon>wb_sunny</mat-icon>
                        &nbsp;&nbsp;{{ soloDosDecimalesConString(temperaturaAmbienteActual) }} ºC
                    </div>
                    <div class="sol-icon1">
                        <mat-icon class="storeIcon">store</mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-body" *ngIf="tanquesEnEstablecimientoActual.length > 0">
            <ng-container *ngFor="let tanque of tanquesEnEstablecimientoActual">
                <div class="row-tanques-completos"> 
                    <div class="imagen-tanque1">
                        <div *ngIf="tanque.cerveza.img !== null">
                            <img
                                [src]="urlBase + '/uploads/imgs/' + tanque.cerveza.img"
                                alt="Tipo de cerveza"
                                class="img-css"
                            />
                        </div>
                        <div *ngIf="tanque.cerveza.img === null" class="not-found-img">
                            <img src="assets/images/icons8-not-found-96.png">
                        </div>
                        <div class="numero-tanque1">
                            <img class="imgTanqueCerveza" src="assets/images/tanque-eg.png" alt="Tanque 1" [ngClass]="{'imagen-con-borde': devolvercondicionTanqueActivo(tanque.id)}"/>
                            <div class="numero-tanque">{{tanque.custom_num}}</div>
                        </div>
                        <div *ngIf="userServiceData.pro_id != 2" class="Consumidos">Consumos del día: <span class="font500">{{soloDosDecimalesConComa(devolverConsumoEnTanque(tanque.device_id, tanque.slot))}} Litros</span></div>
                    </div>

                    <div class="gaugesNivel">
                        <div *ngIf ="gaugesCargados && (!tanque.recargaNecesaria || (tanque.recargaNecesaria && userServiceData.pro_id !== 4 && userServiceData.pro_id !== 2))" class="tituloNivelGauge">
                            Nivel
                        </div>

                        <ng-container *ngIf="tanque.recargaNecesaria && (userServiceData.pro_id == 4 || userServiceData.pro_id == 2)">
                            <button mat-flat-button class="recarga-btn" matTooltip="Solicitar Recarga" aria-label="Solicitar Recarga" 
                            (click)="solicitarRecarga(tanque.id, establecimientoActual.id)"
                            [disabled]="waitAfterSave">
                                Pedir<mat-icon>autorenew</mat-icon>
                            </button>
                        </ng-container>

                        <!--<canvas [id]="'nivelTanque' + tanque.id" data-type="radial-gauge" class="gaugeN"></canvas>-->
                        <div class="graficasNivelContainer">
                            <!-- <canvas [id]="'nivelTanque' + tanque.id" data-type="radial-gauge" class="gaugeN"></canvas> -->
                            <div [id]="'fluidNivelTanque' + tanque.id" class="fluidNivel"></div>
                        </div>

                        <!--<div *ngIf ="gaugesCargados" class="datosNivelGauge">{{soloDosDecimalesConString(devolverNivelActualDelTanque(tanque.id, tanque.slot, tanque.dispositivo, tanque.capacity))}} %</div>-->
                        <div *ngIf ="gaugesCargados && userServiceData.pro_id === 4" class="datosNivelGauge">{{sinDecimales(devolverNivel(tanque.id, tanque.slot, tanque.dispositivo))}} / {{tanque.capacity}} Litros</div>
                        <div *ngIf ="gaugesCargados && userServiceData.pro_id === 1" class="datosNivelGauge"> {{ getNivelFormatted(tanque.id, tanque.slot, tanque.dispositivo) }} / {{tanque.capacity}} Litros</div>
                        <!--<div *ngIf ="gaugesCargados" class="tituloNivelGauge">Nivel</div>-->
                    </div>

                    <div class="gaugesTemperatura">
                        <div *ngIf ="gaugesCargados" class="tituloTemperaturaGauge">Temperatura</div>
                        <canvas [id]="'temperaturaTanque' + tanque.id" data-type="linear-gauge" class="gaugeT"></canvas>
                        <div *ngIf ="gaugesCargados" class="datosTemperaturaGauge">{{soloDosDecimalesConString(devolverTemperaturaActualDelTanque(tanque.id, tanque.slot, tanque.dispositivo))}} °C</div>
                    </div>

                    <div class="gaugesPresion">
                        <div *ngIf ="gaugesCargados" class="tituloPresionGauge">Presión</div>
                        <canvas [id]="'presionTanque' + tanque.id" data-type="radial-gauge" class="gaugeP"></canvas>
                        <div *ngIf ="gaugesCargados" class="datosPresionGauge">{{soloDosDecimalesConString(devolverPresionActualDelTanque(tanque.id, tanque.slot, tanque.dispositivo))}} Bares</div>
                    </div>

                </div>
                <mat-divider class="matDivider"></mat-divider>
            </ng-container>
        </div>
    </div>

    <!--<mat-divider style="width: 90%; margin-right: auto; margin-left: auto;"></mat-divider>-->  
    <div class="graficos-container">
        <div class="graficos-header">
            <span class="consulta-de-historicos">CONSULTA DE HISTÓRICOS</span>
            <div class="consulta-historicos-container">
                
                <div class="historico-fecha">
                    <h4 class="fecha-titulo">Fecha</h4>
                    <mat-form-field class="fecha-form" color="warn">
                        <mat-label class="color-fecha">Selecciona una fecha</mat-label>
                        <mat-date-range-input
                            [formGroup]="selectedDate"
                            [rangePicker]="selectedDatePicker">
                            <input matStartDate placeholder="Start date" formControlName="start" readonly>
                            <input matEndDate placeholder="End date" formControlName="end" readonly>
                        </mat-date-range-input>
                        <mat-hint>Día/Mes/Año</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" class="color-icon-fecha"></mat-datepicker-toggle>
                        <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <div class="form-container">
                    <h4 class="margin-escala">Escala</h4>
                    <mat-form-field color="warn">
                        <mat-label class="color-fecha">Intervalo de tiempo</mat-label>
                        <mat-select [(ngModel)]="selectedValue" name="escala">
                            <mat-option *ngFor="let escala of escalas" [value]="escala.value">
                            <span *ngIf = "!escalaDias">{{escala.viewValue}}</span>
                            <span *ngIf = "escalaDias">24 Horas</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button mat-flat-button class="exportar-btn" (click)="descargarExcel()" 
                *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-icon class="custom-icon">file_download</mat-icon>
                    Exportar Excel
                </button>

                <button mat-flat-button class="aplicar-btn" (click)="getNewGraphicDate()">Aplicar</button>
            </div>
        </div>

        <div class="graficos-body">
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel1" [expanded]="panelEstadisticasAbierto" 
                (closed)="manejarCierrePanel()" (opened)="manejarAperturaPanel()">
                    <mat-expansion-panel-header class="expansion-panel-background">
                        <mat-panel-title class="expansion-tittle">
                            <mat-icon>insert_chart</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp-globales">Estadísticas Globales</b>
                            </div>
                            <mat-icon>insert_chart</mat-icon>
                          </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Cañas (0,33 L)</div>
                            <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Dia</div>
                            <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                            <div class="temperatura-container-titulo">Consumo Total (L)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosConsumoTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-claro">
                                    <span>{{datosEstadisticosConsumoTodos.canhas}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo-medio">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhasDia}}</span>
                                </div>
                                <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo-medio">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhas}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-oscuro">
                                    <span>{{datosEstadisticosConsumoTodos.total}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider class="mat-divider1Custom"></mat-divider>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (ºC)</div>
                            <div class="temperatura-container-titulo">Media (ºC)</div>
                            <div class="temperatura-container-titulo">Máx. (ºC)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosTemperaturaTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-claro">
                                    <span>{{datosEstadisticosTemperaturaTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-medio">
                                    <span>{{datosEstadisticosTemperaturaTodos.media}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-oscuro ">
                                    <span>{{datosEstadisticosTemperaturaTodos.maxima}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider class="mat-divider1Custom"></mat-divider>
                    <div class="expansion-cont  marginBottom20">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (Bar)</div>
                            <div class="temperatura-container-titulo">Media (Bar)</div>
                            <div class="temperatura-container-titulo">Máx. (Bar)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosPresionTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-claro">
                                    <span>{{datosEstadisticosPresionTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-medio">
                                    <span>{{datosEstadisticosPresionTodos.media}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo-oscuro ">
                                    <span>{{datosEstadisticosPresionTodos.maxima}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </mat-expansion-panel>
            </ng-container>

            <!--ESTADÍSTICAS DE CONSUMO-->
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel1">
                    <mat-expansion-panel-header class="color-expansion">
                      <mat-panel-title class="expansion-tittle">
                        <mat-icon>trending_up</mat-icon>
                        <div class="mat-expansion-tittle-position">
                            <b class="tittle-exp-globales">Nivel/Consumo</b>
                        </div>
                        <mat-icon>trending_up</mat-icon>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                
                    <div class="expansion-cont">
                        <ng-container *ngIf="datosEstadisticosConsumo.length !== 0">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo"></div>
                                <div class="temperatura-container-titulo">Cañas (0.33 L)</div>
                                <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Día</div>
                                <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                                <div class="temperatura-container-titulo">Consumo Total (L)</div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let tanque of datosEstadisticosConsumo">
                            <mat-divider *ngIf="datosEstadisticosConsumo.length >= 1" class="mat-divider1"></mat-divider>
                            <div class="temperatura-container-cont">
                                <div class="consumo-container-img"> 
                                    <img
                                        src="{{tanque.imagenURL}}"  
                                        alt="Tipo de cerveza"
                                        class="img-css"
                                    />
                                    <span class="consumoTanqueNombre">{{tanque.nombre}}</span>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-claro">
                                        <span>{{tanque.canhas}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo-medio">
                                        <span>{{tanque.ritmoCanhasDia}}</span>
                                    </div>
                                    <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo-medio">
                                        <span>{{tanque.ritmoCanhas}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-oscuro">
                                        <span>{{tanque.total}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <mat-divider *ngIf="datosEstadisticosConsumo.length !== 0" class="mat-divider1"></mat-divider>
                    </div>
                  </mat-expansion-panel>
            </ng-container>

            <!--GRAFICO NIVEL/CONSUMO-->
            <div class="grafico-NC">

                <button mat-flat-button *ngIf="graficasDatos" class="resetZoomButton" (click)="resetZoomNC()">
                    <img src="assets/images/zoom-out.svg" alt="Zoom Out" class="zoom-icon"/>
                </button> 

                <div class="g-NC">
                    <canvas id="Nivel-Consumo"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>

            </div>

            <!--ESTADÍSTICAS TEMPERATURA-->
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel-other">
                    <mat-expansion-panel-header class="color-expansion">
                      <mat-panel-title class="expansion-tittle">
                        <mat-icon>thermostat</mat-icon>
                        <div class="mat-expansion-tittle-position">
                            <b class="tittle-exp-globales">Temperatura</b>
                        </div>
                        <mat-icon>thermostat</mat-icon>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                
                    <div class="expansion-cont">
                        <ng-container *ngIf="datosEstadisticosTemperatura.length !== 0">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo"></div>
                                <div class="temperatura-container-titulo">Mín. (ºC)</div>
                                <div class="temperatura-container-titulo">Media (ºC)</div>
                                <div class="temperatura-container-titulo">Máx. (ºC)</div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let tanque of datosEstadisticosTemperatura">
                            <mat-divider *ngIf="datosEstadisticosTemperatura.length >= 1" class="mat-divider1"></mat-divider>
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo">
                                    <span class="fontS15">{{tanque.nombre}}</span>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-claro">
                                        <span>{{tanque.minima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-medio">
                                        <span>{{tanque.media}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-oscuro ">
                                        <span>{{tanque.maxima}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <mat-divider *ngIf="datosEstadisticosTemperatura.length !== 0" class="mat-divider1"></mat-divider>
                  </mat-expansion-panel>
            </ng-container>

            <!--GRAFICA TEMPERATURA-->
            <div class="grafico-T">

                <button mat-flat-button *ngIf="graficasDatos" class="resetZoomButton" (click)="resetZoomT()">
                    <img src="assets/images/zoom-out.svg" alt="Zoom Out" class="zoom-icon"/>
                </button> 

                <div class="g-T">
                    <canvas id="Temperatura"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                        <span>Cargando datos...</span>
                        <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                        </div>
                    </div>
                </ng-container>

            </div>

            <!--ESTADISTICAS PRESION-->
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel-other">
                    <mat-expansion-panel-header class="color-expansion">
                      <mat-panel-title class="expansion-tittle">
                        <mat-icon>speed</mat-icon>
                        <div class="mat-expansion-tittle-position">
                            <b class="tittle-exp-globales">Presión</b>
                        </div>
                        <mat-icon>speed</mat-icon>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                
                    <div class="expansion-cont">
                        <ng-container *ngIf="datosEstadisticosPresion.length !== 0">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo"></div>
                                <div class="temperatura-container-titulo">Mín. (Bares)</div>
                                <div class="temperatura-container-titulo">Media (Bares)</div>
                                <div class="temperatura-container-titulo">Máx. (Bares)</div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let tanque of datosEstadisticosPresion">
                            <mat-divider *ngIf="datosEstadisticosPresion.length >= 1" class="mat-divider1"></mat-divider>
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo">
                                    <span class="fontS15">{{tanque.nombre}}</span>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-claro">
                                        <span>{{tanque.minima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-medio">
                                        <span>{{tanque.media}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-amarillo-oscuro ">
                                        <span>{{tanque.maxima}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <mat-divider *ngIf="datosEstadisticosPresion.length !== 0" class="mat-divider1"></mat-divider>
                  </mat-expansion-panel>
            </ng-container>

            <!--GRAFICA PRESION-->
            <div class="grafico-P">

                <button mat-flat-button *ngIf="graficasDatos" class="resetZoomButton" (click)="resetZoomP()">
                    <img src="assets/images/zoom-out.svg" alt="Zoom Out" class="zoom-icon"/>
                </button> 

                <div class="g-P">
                    <canvas id="Presion"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>

            </div>

            

        </div>
    </div>

    <!--<div class="graficos-container">
        <div class="graficos-header">
            <span class="consulta-de-historicos">CONSULTA DE HISTÓRICOS</span>
            <div class="consulta-historicos-container">
                <div class="historico-fecha">
                    <h4 class="fecha-titulo">Fecha</h4>
                    <mat-form-field class="fecha-form" color="warn">
                        <mat-label class="color-fecha">Selecciona una fecha</mat-label>
                        <mat-date-range-input
                            [formGroup]="selectedDate"
                            [rangePicker]="selectedDatePicker">
                            <input matStartDate placeholder="Start date" formControlName="start">
                            <input matEndDate placeholder="End date" formControlName="end">
                        </mat-date-range-input>
                        <mat-hint>Día/Mes/Año</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" class="color-icon-fecha"></mat-datepicker-toggle>
                        <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                    </mat-form-field>
                </div>

                <div class="form-container">
                    <h4 class="margin-escala">Escala</h4>
                    <mat-form-field color="warn">
                        <mat-label class="color-fecha">Intervalo de tiempo</mat-label>
                        <mat-select [(ngModel)]="selectedValue" name="escala">
                            <mat-option *ngFor="let escala of escalas" [value]="escala.value">
                            {{escala.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button mat-flat-button class="exportar-btn" (click)="descargarExcel()" 
                *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-icon class="custom-icon">file_download</mat-icon>
                    Exportar Excel
                </button>

                <button mat-flat-button class="aplicar-btn" (click)="getNewGraphicDate()">Aplicar</button>
            </div>
        </div>

        <div class="graficos-body">
            <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                <mat-expansion-panel class="expansion-panel1" [expanded]="panelEstadisticasAbierto" 
                (closed)="manejarCierrePanel()" (opened)="manejarAperturaPanel()">
                    <mat-expansion-panel-header class="expansion-panel-background">
                        <mat-panel-title class="expansion-tittle">
                            <mat-icon>insert_chart</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Estadísticas Globales</b>
                            </div>
                            <mat-icon>insert_chart</mat-icon>
                          </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (ºC)</div>
                            <div class="temperatura-container-titulo">Máx. (ºC)</div>
                            <div class="temperatura-container-titulo">Media (ºC)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosTemperaturaTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-azul">
                                    <span>{{datosEstadisticosTemperaturaTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-rojo ">
                                    <span>{{datosEstadisticosTemperaturaTodos.maxima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-verde">
                                    <span>{{datosEstadisticosTemperaturaTodos.media}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Mín. (Bar)</div>
                            <div class="temperatura-container-titulo">Máx. (Bar)</div>
                            <div class="temperatura-container-titulo">Media (Bar)</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosPresionTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-azul">
                                    <span>{{datosEstadisticosPresionTodos.minima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-rojo ">
                                    <span>{{datosEstadisticosPresionTodos.maxima}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-verde">
                                    <span>{{datosEstadisticosPresionTodos.media}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="expansion-cont">
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo"></div>
                            <div class="temperatura-container-titulo">Consumo Total (L)</div>
                            <div class="temperatura-container-titulo">Cañas (0,33 L)</div>
                            <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Dia</div>
                            <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                        </div>
                        <div class="temperatura-container-cont">
                            <div class="temperatura-container-titulo">
                                <span class="fontS15">{{datosEstadisticosConsumoTodos.nombre}}</span>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.total}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.canhas}}</span>
                                </div>
                            </div>
                            <div class="temperatura-container">
                                <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhasDia}}</span>
                                </div>
                                <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo">
                                    <span>{{datosEstadisticosConsumoTodos.ritmoCanhas}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel class="expansion-panel1">
                    <mat-expansion-panel-header class="color-expansion">
                      <mat-panel-title class="expansion-tittle">
                        <mat-icon>thermostat</mat-icon>
                        <div class="mat-expansion-tittle-position">
                            <b class="tittle-exp">Temperatura</b>
                        </div>
                        <mat-icon>thermostat</mat-icon>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                
                    <div class="expansion-cont">
                        <ng-container *ngIf="datosEstadisticosTemperatura.length !== 0">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo"></div>
                                <div class="temperatura-container-titulo">Mín. (ºC)</div>
                                <div class="temperatura-container-titulo">Máx. (ºC)</div>
                                <div class="temperatura-container-titulo">Media (ºC)</div>
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let tanque of datosEstadisticosTemperatura">
                            <div class="temperatura-container-cont">
                                <div class="temperatura-container-titulo">
                                    <span class="fontS15">{{tanque.nombre}}</span>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-azul">
                                        <span>{{tanque.minima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-rojo ">
                                        <span>{{tanque.maxima}}</span>
                                    </div>
                                </div>
                                <div class="temperatura-container">
                                    <div class="circulo circulo-verde">
                                        <span>{{tanque.media}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <mat-divider *ngIf="datosEstadisticosTemperatura.length !== 0" class="mat-divider2"></mat-divider>
                </mat-expansion-panel>

            </ng-container>

            <div class="grafico-T">
                <div class="g-T">
                    <canvas id="Temperatura"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                    <span>Cargando datos...</span>
                    <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                    </div>
                    </div>
                </ng-container>
            </div>   
            <div class="grafico-P">
                <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-expansion-panel class="expansion-panel-other">
                        <mat-expansion-panel-header class="color-expansion">
                          <mat-panel-title class="expansion-tittle">
                            <mat-icon>speed</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Presion</b>
                            </div>
                            <mat-icon>speed</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                        <div class="expansion-cont">
                            <ng-container *ngIf="datosEstadisticosPresion.length !== 0">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo"></div>
                                    <div class="temperatura-container-titulo">Mín. (Bares)</div>
                                    <div class="temperatura-container-titulo">Máx. (Bares)</div>
                                    <div class="temperatura-container-titulo">Media (Bares)</div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let tanque of datosEstadisticosPresion">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo">
                                        <span class="fontS15">{{tanque.nombre}}</span>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-azul">
                                            <span>{{tanque.minima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-rojo ">
                                            <span>{{tanque.maxima}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-verde">
                                            <span>{{tanque.media}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <mat-divider *ngIf="datosEstadisticosPresion.length !== 0" class="mat-divider2"></mat-divider>
                      </mat-expansion-panel>
                </ng-container>

                <div class="g-P">
                    <canvas id="Presion"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>
            </div>

            <div class="grafico-NC">
                <ng-container *ngIf="graficasDatos && fechaCambiadaGraficasCargardas">
                    <mat-expansion-panel class="expansion-panel-other">
                        <mat-expansion-panel-header class="color-expansion">
                          <mat-panel-title class="expansion-tittle">
                            <mat-icon>trending_up</mat-icon>
                            <div class="mat-expansion-tittle-position">
                                <b class="tittle-exp">Nivel/Consumo</b>
                            </div>
                            <mat-icon>trending_up</mat-icon>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                    
                        <div class="expansion-cont">
                            <div *ngIf="datosEstadisticosConsumo.length !== 0" class="marginTop20">
                                <span class="consumo-tittle">CONSUMO</span>
                            </div>
                            <ng-container *ngIf="datosEstadisticosConsumo.length !== 0">
                                <div class="temperatura-container-cont">
                                    <div class="temperatura-container-titulo"></div>
                                    <div class="temperatura-container-titulo">Consumo Total (L)</div>
                                    <div class="temperatura-container-titulo">Cañas (0.33 L)</div>
                                    <div *ngIf="diferenciaDias > 2" class="temperatura-container-titulo">Cañas por Día</div>
                                    <div *ngIf="diferenciaDias <= 2" class="temperatura-container-titulo">Cañas por Hora</div>
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let tanque of datosEstadisticosConsumo">
                                <mat-divider *ngIf="datosEstadisticosConsumo.length >= 1" class="mat-divider1"></mat-divider>
                                <div class="temperatura-container-cont">
                                    <div class="consumo-container-img"> 
                                        <img
                                            src="{{tanque.imagenURL}}"  
                                            alt="Tipo de cerveza"
                                            class="img-css"
                                        />
                                        <span class="consumoTanqueNombre">{{tanque.nombre}}</span>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-amarillo">
                                            <span>{{tanque.total}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div class="circulo circulo-amarillo">
                                            <span>{{tanque.canhas}}</span>
                                        </div>
                                    </div>
                                    <div class="temperatura-container">
                                        <div *ngIf="diferenciaDias > 2" class="circulo circulo-amarillo">
                                            <span>{{tanque.ritmoCanhasDia}}</span>
                                        </div>
                                        <div *ngIf="diferenciaDias <= 2" class="circulo circulo-amarillo">
                                            <span>{{tanque.ritmoCanhas}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <mat-divider *ngIf="datosEstadisticosConsumo.length !== 0" class="mat-divider1"></mat-divider>
                        </div>
                      </mat-expansion-panel>
                </ng-container>

                <div class="g-NC">
                    <canvas id="Nivel-Consumo"></canvas>
                </div>

                <div *ngIf="!graficasDatos" class="no-hay-datos">
                    <span class="color-gray"> {{mensajeNoHayDatos}}</span>
                    <div class="mensaje-no-hay">
                        <img src="assets/images/icons8-not-found-96.png">
                    </div>
                </div>

                <ng-container *ngIf="!fechaCambiadaGraficasCargardas">
                    <div class="cargando-animation">
                      <span>Cargando datos...</span>
                      <div>
                        <img src="assets/images/canalejas/loading.gif" 
                        alt="Cargando..."
                        class="cargando"/>
                      </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>-->

    <div class="header-table">
        <span class="font500">LISTADO DE TANQUES</span>
    </div>
    <div class="bdy-table">
        <table mat-table [dataSource]="dataSource" matSort class="tableTanques" #sort1="matSort">

            <ng-container matColumnDef="nombreTanque">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID tanque</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.nombreTanque}} </td>
            </ng-container>

            <ng-container matColumnDef="numero">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº tanque</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.numero}} </td>
            </ng-container>

            <ng-container matColumnDef="espacio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Pos. en Dis.</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.espacio}} </td>
            </ng-container>

            <ng-container matColumnDef="cerveza">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cerveza</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.cerveza}} </td>
            </ng-container>

            <ng-container matColumnDef="capacidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Capacidad (L)</th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.capacidad}} </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver tanque" aria-label="Ver tanque" routerLink="/tanque/{{element.id}}">
                        <mat-icon>remove_red_eye</mat-icon>
                    </button>
                    <button *ngIf = "userServiceData.pro_id == 4 || userServiceData.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar tanque" aria-label="Editar tanque" routerLink="/tanques/{{element.id}}/editar">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsTanques"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsTanques;"></tr>
        </table>
    </div>

    <div class="header-table" *ngIf="hayAlarmasDesactivadas">
        <span class="font500">HISTORICO DE ALARMAS DEL ESTABLECIMIENTO</span>
    </div>
    <div class="bdy-table" *ngIf="hayAlarmasDesactivadas">
        <table mat-table [dataSource]="dataSourceAlarms" matSort #sort3="matSort">

            <ng-container matColumnDef="deviceLabel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Dispositivo </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{ element.deviceLabel }} ({{ element.deviceRef }}) </td>
            </ng-container>

            <ng-container matColumnDef="f_inicio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Inicio </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_inicio}} </td>
            </ng-container>

            <ng-container matColumnDef="f_fin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Fin </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.f_fin}} </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.type}} </td>
            </ng-container>

            <ng-container matColumnDef="valorAlarma">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor Alarma </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.valorAlarma}} </td>
            </ng-container>

            <ng-container matColumnDef="rango">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rango de Alarma </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.rango}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator #paginator1
            [pageSizeOptions]="[10,20,40]"  
            showFirstLastButtons 
            aria-label="Elige una página"
            class="paginator">
        </mat-paginator>
    </div>

    <!--DATOS DISPOSITIVO-->
    <div class="wrap">
        <div class="datos-dispositivo-container">
            <div class="datos-dispositivo-titulo font500">DATOS ESTABLECIMIENTO</div>
            <div class="datos-dispositivo-body">
                <mat-list>
                    <mat-list-item class="list-item">
                        <span class="label">Nombre</span> 
                    </mat-list-item>
                    <mat-list-item class="list-item">
                        <span class="label">Dirección</span> 
                    </mat-list-item>
                    <mat-list-item class="list-item">
                        <span class="label">Fecha de alta</span> 
                    </mat-list-item>                   
                    <mat-list-item class="list-item">
                        <span class="label">Estado</span>   
                    </mat-list-item>
                </mat-list>
                <mat-list>
                    <mat-list-item class="list-item">
                        <span class="valor">{{establecimientoActual.est_name}}</span> 
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">
                        <span class="valor">{{establecimientoActual.address}}</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">
                        <span class="valor">{{devolverUltimaLecturaFormateada(establecimientoActual.created_at)}}</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="list-item">   
                        <span class="valor" *ngIf="establecimientoActual.status == 1">Activado</span>
                        <span class="valor" *ngIf="establecimientoActual.status == 0">Desactivado</span>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>
            </div>
            <div class="imagen-dipositivo">
                <img [src]="urlBase + '/uploads/imgs/' + establecimientoActual.est_imgs">
            </div>
            <div class="editar-btn-container" *ngIf = "userServiceData.pro_id == 4 || userServiceData.pro_id == 1">
                <button mat-flat-button class="editar-btn" routerLink="/{{establecimientoActual.id}}/editar/establecimiento">Editar</button>
            </div>
        </div>

        <!--UBICACIÓN-->
        <div class="map-container">
            <div class="map-header">
                <span class="font500">UBICACIÓN DEL ESTABLECIMIENTO</span>
            </div>
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid">
                    <agm-marker [latitude]="lat" [longitude]="lng" iconUrl="assets/images/marker.png"></agm-marker>
                </agm-map>-->
                <div id="map" class="mapHeight"></div>
        </div>
    </div>

    <div class="footer"></div>
</ng-template>